import cabecalho from '@/components/global/Cabecalho/Cabecalho.vue'
import menuLateral from '@/components/global/MenuLateral/MenuLateral.vue'
import pagination from '@/components/layout/pagination/Pagination.vue'
import { BModal, BSpinner, BToast } from 'bootstrap-vue'
import mensagens from '@/util/mensagens'
import util from '@/util'
import imageStream from '@/components/layout/imageStream/ImageStream.vue'
import { mapState } from 'vuex'

export default {
  name: 'galeriaFotos-administracao',
  components: {
    cabecalho,
    menuLateral,
    pagination,
    imageStream,
    'b-modal': BModal,
    'b-spinner': BSpinner,
    'b-toast': BToast
  },

  computed: {
    ...mapState('pagination', ['registrosPorPagina']),
    tabelaSemRegistros () {
      return this.listaAlbuns.length === 0
    }
  },

  data: () => {
    return {
      listaAlbuns: [],
      flagsDeControle: {
        carregandoDados: {
          status: false,
          mensagem: ''
        }
      },
      componentePaginacao: {
        pagina: 1,
        registrosPorPagina: null,
        fonteDeDados: [],
        ultimaPagina: 1
      },
      retorno: {
        sucesso: false,
        mensagem: ''
      },
      idAlbum: null
    }
  },

  mounted () {
    this.componentePaginacao.registrosPorPagina = this.registrosPorPagina
    this.obterListaAlbuns()
  },

  methods: {
    async obterListaAlbuns () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)

        let parametrosRequisicao = {
          'page': this.componentePaginacao.pagina,
          'registrosPorPagina': this.componentePaginacao.registrosPorPagina
        }
        const resposta = await this.axios.post('/albuns', parametrosRequisicao)
        this.listaAlbuns = resposta.data.retorno.dados
        this.componentePaginacao.fonteDeDados = resposta.data.retorno.paginacao
        this.componentePaginacao.ultimaPagina = resposta.data.retorno.paginacao.ultimaPagina
      } catch (e) {
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaServidorCarregandoDados)
      }
      this.definirFlagCarregandoDados(false, '')
    },

    definirFlagCarregandoDados (status, mensagem) {
      this.flagsDeControle.carregandoDados.status = status
      this.flagsDeControle.carregandoDados.mensagem = mensagem
    },

    obterDadosPaginados (pagina, registrosPorPagina) {
      this.componentePaginacao.pagina = pagina
      this.componentePaginacao.registrosPorPagina = registrosPorPagina
      this.obterListaAlbuns()
    },

    incluirAlbum () {
      this.$router.push({ name: 'cadastro-galeriaFotos' })
    },

    detalhesAlbum (id) {
      this.$router.push({ name: 'detalhes-administracao', params: { id: id } })
    },

    editarAlbum (id) {
      this.$router.push({ name: 'edicao-galeriaFotos', params: { id: id } })
    },

    showModalExcluirAlbum (id) {
      this.idAlbum = id
      this.$bvModal.show('modalExcluir')
    },

    async excluirAlbum () {
      try {
        this.definirFlagCarregandoDados(true, mensagens.carregandoDadosEdicao)
        const resposta = await this.axios.delete('/album/' + this.idAlbum + '/remover')
        this.definirFlagCarregandoDados(false, '')
        this.retorno.sucesso = resposta.data.retorno.sucesso
        this.retorno.mensagem = resposta.data.retorno.mensagem

        if (this.retorno.sucesso) {
          util.criarAlertaToastDeSucesso(this, 'Aviso', this.retorno.mensagem)
        } else {
          util.criarAlertaToastDeErro(this, 'Aviso', this.retorno.mensagem)
        }
        this.componentePaginacao.pagina = 1
        this.obterListaAlbuns()
      } catch (e) {
        this.definirFlagCarregandoDados(false, '')
        util.criarAlertaToastDeErro(this, 'Aviso', mensagens.falhaComunicacaoServidor)
      }
    }
  }
}
